<template>
    <div>
        <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(item, index) in list" :key="index">
                <img :src="item.url" class="pic">
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"/>
        </swiper>
        <div class="delete-btn" v-show="isDelete">
            <el-button @click="handleRemove(num)" type="text">
                <i class="el-icon-delete"/> 刪除
            </el-button>
        </div>
    </div>
</template>

<script>
    /*todo 輪播組件Swiper只支援vue3，要另外用外掛vue-awesome-swiper
       demo https://github.surmon.me/vue-awesome-swiper/
       swiper4-6功能中文網 https://www.swiper.com.cn/api/autoplay/19.html*/
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    let vm = null;
    export default {
        name: "StallPhotoSlider",
        props: {
            list: { type:Array, default: Array.of([]) },  // list = [url:string, imgUrl:string]
            url: {default: ''},
            fileNum:{},
            isDelete:{default: true},//是否顯示刪除按鈕
        },
        components: {
            Swiper,
            SwiperSlide
        },
        computed: {

        },
        data() {
            return {
                num: this.fileNum,
                //輪播用
                swiperOptions: {
                    loop: false,
                    autoplay: {
                        delay: 3000,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    on: {
                        slideChange(){
                            // 这里有坑，需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
                            const index = this.activeIndex
                            vm.tabNumber(index);
                        },
                    }
                },
            }
        },
        created() {
            vm = this;
        },
        mounted() {
            this.$refs.mySwiper.$swiper.slideTo(this.fileNum)

        },
        methods: {
            handleRemove(file) {
                this.$emit("value-remove", this.list[file])
                if(this.list.length===0){
                    this.$emit("value-close")
                }
            },
            tabNumber(index) {
                this.num=index
            },
        },
        watch:{
            fileNum(){
                this.$refs.mySwiper.$swiper.slideTo(this.fileNum)
            }
        },
    }
</script>

<style scoped lang="less">
    //輪播用
    /deep/.swiper-container{
        .pic{
            width: auto;
            max-width: 100%;
            max-height: 60vh;
        }
        .swiper-pagination{
            .swiper-pagination-bullet{
                background: #fff;
            }
            .swiper-pagination-bullet-active{
                background: var(--color-yellow);
            }

        }
        .swiper-slide{
            margin: auto 0;
            text-align: center;
        }
    }
    .delete-btn{
        text-align: center;
        margin: 10px 0 0;
        .el-button--text{
            color: #fff;
        }
    }
</style>
